import { gql } from '@apollo/client';

const appraisalNotificationFragment = gql`
  fragment AppraisalNotificationFields on AppraisalNotification {
    OrgUnitId
    ConductEndDate
  }
`;

export default appraisalNotificationFragment;
